/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PolicyOperationLabelEnum;

(function (PolicyOperationLabelEnum) {
  PolicyOperationLabelEnum["DRAFT"] = "draft";
  PolicyOperationLabelEnum["CONFIRMED"] = "confirmed";
  PolicyOperationLabelEnum["EFFECTIVE"] = "effective";
  PolicyOperationLabelEnum["VOID"] = "void";
})(PolicyOperationLabelEnum || (PolicyOperationLabelEnum = {}));